/*
  CO - Troca de cor leva aos tamanhos disponíveis (conso-variant-main-picker-cor).

  Problema: no Costume (bundle), trocar a cor mantém os tamanhos marcados. Se a
  combinação nova está esgotada (ex.: paletó 44 na Areia, sem reposição), a PDP
  mostra "esgotado" mesmo havendo a cor em outros tamanhos.

  O que faz: no clique de uma COR, se a combinação (cor nova + tamanhos atuais)
  não está disponível, marca a variante disponível daquela cor que mantém o maior
  número de tamanhos já escolhidos (empate: a primeira na ordem do produto).

  Por que funciona sem segundo fetch: o variant-picker.js do Horizon monta o
  pedido a partir dos inputs :checked no momento do `change`. Este listener roda
  em capture no `window`, ANTES do listener do <variant-picker>, então o Horizon
  já busca a variante certa. Também corrige o data-variant-id do input da cor,
  que o Horizon usa para o ?variant= da URL.

  Dados: <script data-conso-cor-tamanhos> dentro do <variant-picker>.
  Sem o script (produto sem cor), não faz nada.
*/
(() => {
  if (window.__consoCorTamanhos) return;
  window.__consoCorTamanhos = true;

  /** @param {HTMLInputElement} input */
  const optionPos = (input) => Number((input.dataset.inputId || '').split('-')[0]);

  window.addEventListener(
    'change',
    (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;

      const picker = input.closest('variant-picker');
      const dataEl = picker && picker.querySelector('script[data-conso-cor-tamanhos]');
      if (!dataEl) return;

      let data;
      try {
        data = JSON.parse(dataEl.textContent || '');
      } catch (e) {
        return;
      }

      const corPos = data.cor;
      if (optionPos(input) !== corPos) return;

      // Seleção atual por posição da opção (1-based), já com a cor nova.
      /** @type {Record<number, string>} */
      const sel = {};
      picker.querySelectorAll('fieldset input:checked').forEach((el) => {
        sel[optionPos(/** @type {HTMLInputElement} */ (el))] = /** @type {HTMLInputElement} */ (el).value;
      });
      sel[corPos] = input.value;

      const positions = Object.keys(sel).map(Number);
      const matches = (v) => positions.every((p) => v[p - 1] === sel[p]);

      const exact = data.v.find(matches);
      if (exact && exact[3]) return;

      let best = null;
      let bestScore = -1;
      for (const v of data.v) {
        if (!v[3] || v[corPos - 1] !== input.value) continue;
        const score = positions.filter((p) => p !== corPos && v[p - 1] === sel[p]).length;
        if (score > bestScore) {
          best = v;
          bestScore = score;
        }
      }
      if (!best) return;

      positions.forEach((p) => {
        if (p === corPos) return;
        const alvo = Array.from(picker.querySelectorAll('fieldset input[type="radio"]')).find(
          (el) => optionPos(/** @type {HTMLInputElement} */ (el)) === p && /** @type {HTMLInputElement} */ (el).value === best[p - 1]
        );
        if (alvo) /** @type {HTMLInputElement} */ (alvo).checked = true;
      });

      input.dataset.variantId = String(best[4]);
    },
    true
  );
})();
